// extracted by mini-css-extract-plugin
module.exports = {"width":"Width_width__WYtMH"};